import script from "./tasks.vue?vue&type=script&setup=true&lang=ts"
export * from "./tasks.vue?vue&type=script&setup=true&lang=ts"

import "./tasks.vue?vue&type=style&index=0&id=54487ca2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54487ca2"]])

export default __exports__